export enum NotificationFilterOptions {
  all = 'all',
  unread = 'unread',
  read = 'read',
  assignment = 'assignment',
  comment = 'comment',
  mention = 'mention',
}
